import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import ContentstackImage from '@/components/ContentstackImage';
import SignUpButton from '@/components/premium/SignUpButton';
import IconComponent from '@/components/premium/utilities/IconComponent';
import { useFeatureFlagsProvider } from '@/hooks/featureFlags';
import { PODERsalud } from '@/icons/premium';
import CouponAlert from '@separate/components/CouponAlert';
import { PREMIUM_MEMBERSHIP_AS_CURRENCY } from "@separate/constants/premium";
import { useTranslation } from '@separate/hooks/translation';
import { useCurrentUser } from '@separate/hooks/user';
import styles from './heroComponent.module.scss';

export default function HeroComponent({ couponText }) {
  const { isLoading: isUserLoading, isLoggedIn, user } = useCurrentUser();
  const { t } = useTranslation();

  const isPremiumMember = isLoggedIn && user?.is_premium_member;
  const premiumBenefits = [ ...t(`premium.landing.main.premium_benefits`, { returnObjects: true }) ];

  const [featureFlag, setFeatureFlag] = React.useState('default');
  const posthogClient = useFeatureFlagsProvider();

  React.useEffect(() => {
    if(!posthogClient) return;
    const value = posthogClient.getFeatureFlag('value-change-test-feature'); // this will add "Feature Flag Called"
    setFeatureFlag(value);
  }, [posthogClient]);

  return (
    <div>
      <Row className={cx(styles.main, "pt-5 pb-2 justify-content-center", { [styles.moveImageDown]: couponText })}>
        {couponText && <CouponAlert className={styles.mobileOnly} coupon={couponText} />}
        <div>
          {/* <h2 className={cx(styles.featureFlag, styles[featureFlag], "pb-0 mb-0")}>{featureFlag}</h2> */}
          <div className={cx(styles.desktopOnly)}>
            <h1>{t("premium.landing.main.title")}</h1>
            <h2 dangerouslySetInnerHTML={{__html: t('premium.landing.main.subtitle')}} />
          </div>
          <div className={cx(styles.headingMatter)}>
            <PODERsalud />
            <h2 dangerouslySetInnerHTML={{__html: t('premium.landing.main.subtitle_mobile')}} />
          </div>

          <div className={styles.premiumBenefits}>
            {premiumBenefits.map((item) => (
              <div className={cx("d-flex", "mb-3")} key={item.title}>
                <IconComponent name={item.icon} />
                <p>{item.title}</p>
              </div>
            ))}
          </div>

          <div className={styles.imageDesktop}>
            <ContentstackImage
              src="https://images.contentstack.io/v3/assets/blt224b6cd2a9d5dbf3/bltcf0ea0f58247fdde/62e3e0e719ee366ebba56200/SEP_Membership_Hero_Asset.png"
              alt="SEP+"
              width={600}
            />
          </div>
          <div className={cx(styles.signUpButtonWrapper, "text-center mt-4 mb-2")}>
            <SignUpButton
              loading={isUserLoading}
              isLoggedIn={isLoggedIn}
              isPremiumMember={isPremiumMember}
              className={cx(styles.button, "py-2")}
              couponText={couponText}
            />
          </div>

          <div className={styles.priceWrapper}>
            <p>
              <span className="fst-italic">
                {t("premium.landing.main.only")}
              </span>{" "}
              <span className={styles.price}>
                {PREMIUM_MEMBERSHIP_AS_CURRENCY}
              </span>{" "}
              <span className={styles.month}>
                {t("premium.landing.main.per_month")}
              </span>
            </p>
          </div>
        </div>
      </Row>
    </div>
  );
}

HeroComponent.propTypes = {
  couponText: PropTypes.any
};
